<script>
  import { External, M } from '../../../external';
  import { onDestroy, onMount } from 'svelte';
  import { ignore } from '../../../Common/tools';

  export let data = {}, onChange = ignore, valid;

  if (!data.settings) {
    data.settings = [];
  }

  let webhook = data.settings[0] ? JSON.parse(data.settings[0].value) :
    {
      url: '',
      headers: [],
      secret: External.WebPlatform.getRandomString(16)
    };

  let addHeader = () => {
    if (webhook.headers.length < 30) {
      webhook.headers.push({
        name: '',
        value: ''
      });
      webhook.headers = webhook.headers;
    }
    onSettingsChanged();
  };

  let removeHeader = () => {
    if (webhook.headers.length > 1) {
      webhook.headers.pop();
    } else if (webhook.headers.length === 1) {
      webhook.headers[0].name = '';
      webhook.headers[0].value = '';
    }
    webhook.headers = webhook.headers;
    onSettingsChanged();
  };

  let validateWebhook = () => {
    try {
      new URL(webhook.url);
    } catch (e) {
      return false;
    }
    return !!!webhook.headers.find(header => //check that none have a name but no value or vice-versa
      (header.name.length && !header.value.length) ||
      (!header.name.length && header.value.length)
    );
  };

  let onSettingsChanged = () => {
    valid = validateWebhook();
    if (valid) {
      data.settings[0] = {
        key: '0',
        value: JSON.stringify({
          url: webhook.url,
          headers: webhook.headers,
          secret: webhook.secret
        })
      };
      onChange();
    }
  }

  let copySecret = () => {
    External.Tools.copyToClipboard(webhook.secret);
    External.Tools.showCornerMessage(1000, M.COPIED_TO_CLIPBOARD, External.Tools.TOOLTIP_TYPE_SUCCESS);
  }

  onMount(() => {
    if (webhook.headers.length === 0) {
      addHeader();
    }
  });

  onDestroy(() => {
    webhook = null;
  });
</script>

<div class='col20 f-left small-rules mb-25'>
  <h4 class='col20 f-left mt-5 mb-25 t-center' style='line-height:1.4;'>{M.OTHER_WEBHOOK_TRIGGER}</h4>
  <div class='col20 f-left mt-25'>
    <div class='info'>
      <h5>{M.WEBHOOK_DESTINATION_URL}</h5>
      <span class='light-gray-text'>{M.WEBHOOK_DESTINATION_URL_DESC}</span>
    </div>
    <div class='popup-input-wrapper'>
      <input type='text' bind:value={webhook.url} placeholder={M.ENTER_DESTINATION_URL} on:change={onSettingsChanged} />
    </div>
  </div>

  <div class='col20 f-left'>
    <div class='col20 f-left'>
      <div class='info'>
        <h5>{M.REQUEST_HEADERS}</h5>
        <span class='light-gray-text'>{M.REQUEST_HEADERS_DESC}</span>
      </div>
      {#key webhook.headers.length}
        {#each webhook.headers as header}
          <div class='mb-5'>
            <input type='text' class='modify transition-border half-input f-left' bind:value={header.name} placeholder={M.NAME} on:change={onSettingsChanged} />
            <input type='text' class='modify transition-border half-input f-right' bind:value={header.value} placeholder={M.VALUE} on:change={onSettingsChanged} />
          </div>
        {/each}
      {/key}
      <div class='popup-input-wrapper'>
        <a class='middle-button light-gray-button circle-effect add-email-tags-btn f-right ml-5' style='position: relative'
           on:click={addHeader}>{M.ADD}</a>
        <a class='middle-button light-gray-button circle-effect add-email-tags-btn f-right' style='position: relative'
           on:click={removeHeader}>{M.REMOVE}</a>
      </div>
    </div>
  </div>

  <div class='col20 f-left mt-10'>
    <div class='info'>
      <h5 class="col20 f-left mb-5">{M.WEBHOOK_SECRET}</h5>
      <span class='light-gray-text col20 f-left'>{M.WEBHOOK_SECRET_DESC}</span>
      <div class='info mt-15 flex align-center'>
        <a class="flex align-center" on:click={copySecret}>
          <b><u>{webhook.secret}</u></b> 
          <span class="small-button blue inline-block ml-5 rounded-effect">{M.COPY}</span>
        </a>
        <span class="material-icons-outlined ml-5 stats-info" style="font-size: 20px;padding: 5px;">info
                  <span class="none hidden-info left-info"><span>Each request to your destination URL is signed using the webhook secret. The signature is passed in the X-Webhook-Signature header and can be used to verify that the events were sent by us and not by a third party. To verify the signature, generate the HMAC hex digest using the SHA-512 hash function and the webhook secret as the HMAC key. Then compare it with the X-Webhook-Signature from the request.</span></span></span>
      </div>
      <span class='light-gray-text f-left mt-15'>
          
        </span>
    </div>
  </div>
</div>
